var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-box",class:{ 'active': _vm.isActive},on:{"click":function($event){$event.stopPropagation();return _vm.handleSquareBoxClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }